// extracted by mini-css-extract-plugin
export var avatarContainer = "_3m-1";
export var largeAvatarContainer = "_3m-2";
export var smallAvatarContainer = "_3m-0";